import { useContext } from "react";
import SentimentDrivers from "../SentimentDriver/SentimentDriver";
import BrandSummary from "../BrandSummary/BrandSummary";
import { DiscoveryContext, useIsSelectedSection } from "../discovery-context";
import AttributesOverview from "../Attributes/AttributesOverview";
import SourcesOverview from "../Sources/sourcesOverview";
import FocusAreaOverView from "../FocusArea/focusArea";
import MUISelect from "../../../Component/UI/MUISelect/MUISelect";
import classes from "./BrandOverview.module.css";
import { LLM_OPTIONS } from "../../../utils/constant";
import { tab } from "../BrandScore/BrandScore";
import Checkbox from "@mui/material/Checkbox";
import { filterKey } from "../BrandAudit";
import {OVERVIEW_LLM_LABELS} from "../../../utils/constant"
import DashboardCheckbox from "../SelectedComponent/DashboardCheckbox";
import { ENTITY_LABELS } from "../../../utils/labelMapping";


export default function BrandOverview() {
  const discoveryCtx = useContext(DiscoveryContext);
  const selectedMarket = discoveryCtx?.state?.selectedMarket;
  const primaryMarket = discoveryCtx?.state?.market;
  const isShowAttributeOverview = selectedMarket === primaryMarket;
  const id = `Sentiment_Drivers`;
  const { checked, uniqueKey } = useIsSelectedSection({
    id,
    tab: tab.brandOverview,
  });
  return (
    <div className={classes.containerWrapper}>
       {discoveryCtx.state.showReportCheckbox && (
        <DashboardCheckbox
          dashboardTab={tab.brandOverview}
          dashboardName={`${discoveryCtx.type === "brand" ? ENTITY_LABELS.brand : ENTITY_LABELS.product} Overview`}
        />
      )}
      <BrandSummary />
      <div className={classes.headerWrapper}>
        <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
          <h5 className={classes.heading}>{discoveryCtx?.mapMetricTitle?.("Sentiment Drivers") ?? "Sentiment Drivers"}</h5>
          {discoveryCtx.state.showReportCheckbox && (
            <Checkbox
              checked={checked}
              onChange={() => {
                discoveryCtx?.clickComponentCheckbox({
                  uniqueKey,
                  filter: {
                    id: id,
                    title: discoveryCtx?.mapMetricTitle?.("Sentiment Driver") ?? "Sentiment Driver",
                    tab: tab.brandOverview,
                    uniqueKey,
                  },
                  checked,
                  id,
                });
              }}
              inputProps={{ "aria-label": "controlled" }}
            />
          )}
        </div>

        <div className={classes.dropdownWrapper}>
          <MUISelect
            fullWidth={false}
            optionValue={discoveryCtx.state.selectedLLM}
            label={"LLM"}
            id={filterKey.llm}
            options={(discoveryCtx.llm || []).map((llm) => {
              const match= OVERVIEW_LLM_LABELS[llm]
              return {
                name: match ? match : llm,
                value: llm,
              };
            })}
            onChange={(e) => {
              discoveryCtx.updateSelectedLLM(e.target.value);
            }}
          />
          <MUISelect
            fullWidth={false}
            optionValue={discoveryCtx.state.selectedCategory}
            label={"Category"}
            id={filterKey.category}
            options={(discoveryCtx.category || []).map((category) => {
              return {
                name: category,
                value: category,
              };
            })}
            onChange={(e) => {
              discoveryCtx.updateSelectedCategory(e.target.value);
            }}
          />
        </div>
      </div>
      <SentimentDrivers isSelectedMarket={true} id={id} />
      {isShowAttributeOverview && <AttributesOverview />}
      <SourcesOverview />
      <FocusAreaOverView />
    </div>
  );
}
